import { render, staticRenderFns } from "./CreateWizardObjectPopUp.vue?vue&type=template&id=4801de0e&scoped=true"
import script from "./CreateWizardObjectPopUp.vue?vue&type=script&lang=js"
export * from "./CreateWizardObjectPopUp.vue?vue&type=script&lang=js"
import style0 from "./CreateWizardObjectPopUp.vue?vue&type=style&index=0&id=4801de0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4801de0e",
  null
  
)

export default component.exports